import { Button } from 'reactstrap';
import { LatePaymentPenalty } from '../models/contractModel';
import FormModal from '../../../components/modals/FormModal';
import useModalState from '../../../hooks/useModalState';
import ContractPenaltiesForm from './ContracPenaltiesForm';
import useContract from '../hooks/useContract';

interface Props {
  id: string;
  penalties: LatePaymentPenalty[];
}

const ContractUpdatePenaltiesModal = ({ id, penalties }: Props) => {
  const { doUpdateContractPenalties } = useContract();
  const [isOpenModal, toggleModal] = useModalState();

  const handleConfirmation = (penalties: LatePaymentPenalty[]) => {
    //call ep to update penalties
    doUpdateContractPenalties(id, penalties).then().catch();
  };

  return (
    <>
      <Button color="info" onClick={() => toggleModal()}>
        <i className="ni ni-settings-gear-65" />
        <span className="nav-link-inner--text">Actualizar penalizaciones</span>
      </Button>
      <FormModal
        isOpen={isOpenModal}
        onToggle={toggleModal}
        headerText="Actualizar penalizaciones"
        abortText="Cancelar"
        onConfirmation={() => {}}
        onReset={() => {}}
        children={
          <ContractPenaltiesForm
            penalties={penalties}
            handleConfirmation={handleConfirmation}
          />
        }
        size="xl"
        withFooterActions={false}
      />
    </>
  );
};

export default ContractUpdatePenaltiesModal;
